import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { OrderWithContext } from '@/models';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgOrderDiscounts',
})
export default class CmgOrderDiscounts extends Vue {
  @Prop({ required: true, type: Object })
  order!: OrderWithContext;

  get discounts() {
    return this.order.order.discounts || [];
  }

  get promos() {
    return this.getPromosOrRewards(true);
  }

  get rewards() {
    return this.getPromosOrRewards(false);
  }

  get isUK() {
    return this.$appStore.state.ui.countryProfile.countryCode == CountryCode.UK;  
  }

  getDiscountValue(discount: any) {
      return '-' + this.formatPrice(discount.discountAmount);
  }

  getPromosOrRewards(getPromos: boolean) {
    return this.discounts.filter(d => d.discountIsReusable == getPromos);
  }

  formatPrice(price: number | null): string {
    return this.$services.utils.formatPrice(price);
  }
}
